import React from 'react';
import PropTypes from 'prop-types';

import FilePreview from './FilePreview';
import styles from './filePreviewer.css';

const FilePreviewer = ({ files, fileMetaById, removeFile }) => (
  <div className={styles.previews}>
    {files.map((file) => {
      const { metaId } = file;
      const { progress: uploadProgress } = fileMetaById[metaId];
      return (
        <FilePreview
          file={file}
          key={metaId}
          uploadProgress={uploadProgress}
          onRemoveFile={() => removeFile(metaId)}
        />
      );
    })}
    {!files.length && <div className={styles.previewPlaceholder} />}
  </div>
);

FilePreviewer.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({ metaId: PropTypes.string })).isRequired,
  fileMetaById: PropTypes.objectOf(PropTypes.shape({ progress: PropTypes.number })).isRequired,
  removeFile: PropTypes.func.isRequired,
};

export default FilePreviewer;
